import React from 'react';

const TextMessage = props => {
  return <div className="sc-message--text">{props.message}</div>;
};

export default TextMessage;
